<template>
  <div class="popvalet-pro-services-camion screen">
    <common-sur-header />
    <common-header
        :nav-items="header.navItems"
        :cta-buttons="header.ctaButtons"
    />
    <pro-services-header text="Transport par Camion" :icon-url="require('../../img/truck.png')"/>
    <pro-services-intro :intro-text="introText" :services="services"/>
    <pro-services-picture :picture-url="pictureUrl"/>
    <pro-services-avantages :avantages="avantages"/>
    <multimodalite-camion/>
    <common-footer></common-footer>
  </div>
</template>

<script>
import CommonHeader from "@/components/common/CommonHeader";
import CommonSurHeader from "@/components/common/CommonSurHeader";
import CommonFooter from "@/components/common/CommonFooter";
import ProServicesHeader from "@/components/ProServicesHeader";
import ProServicesIntro from "@/components/ProServicesIntro";
import ProServicesPicture from "@/components/ProServicesPicture";
import ProServicesAvantages from "@/components/ProServicesAvantages";
import MultimodaliteCamion from "@/components/MultimodaliteCamion";
export default {
  name: "PopvaletProServicesCamion",
  components: {
    CommonHeader,
    CommonSurHeader,
    ProServicesHeader,
    ProServicesIntro,
    ProServicesPicture,
    ProServicesAvantages,
    MultimodaliteCamion,
    CommonFooter,
  },
  props: [
    'header',
    'introText',
    'services',
    'pictureUrl',
    'avantages'
  ],
};
</script>

<style scoped>
.popvalet-pro-services-camion {
  width: 100%;
}
</style>
